export default __webpack_public_path__ + "static/media/Identify-Reg-compliance.b7c93a5b.svg";